<script>
import { createNamespacedHelpers } from 'vuex'
const { mapMutations, mapState } = createNamespacedHelpers('nav')
import { mapState as mapGenericState } from 'vuex'
import throttle from 'lodash/throttle'

export default {
  data() {
    return {
      prevScroll: 99999,
      hideNavbar: false,
    }
  },
  computed: {
    ...mapState([
      'mobileSidebarOpen',
      'desktopSidebarOpen',
      'scrollAtTop',
      'sidebarSubMenu',
      'announcementBarExists',
    ]),
    ...mapGenericState('cart', ['itemCount']),
  },
  created() {
    let navTrees = JSON.parse(document.getElementById('data-nav-tree').innerHTML)
    this.setDesktopNavTree([...navTrees.desktopNavTree, ...(navTrees.rightSideNavTree || [])])
    this.setMobileNavTree(navTrees.mobileNavTree)

    this.handleThrottledScroll = throttle(this.handleScroll, 100)
    window.addEventListener('scroll', this.handleThrottledScroll)
    const barExists =
      !!document.getElementById('shopify-section-announcement-bar') &&
      document.getElementById('shopify-section-announcement-bar').children.length > 0
    this.setAnnouncementBarExists(barExists)
    console.log({ barExists })
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleThrottledScroll)
  },
  methods: {
    ...mapMutations([
      'setDesktopNavTree',
      'setMobileNavTree',
      'setScrollAtTop',
      'toggleMobileSidebar',
      'toggleDesktopSidebar',
      'setAnnouncementBarExists',
    ]),
    handleScroll() {
      // Check if we're scrolling up or down
      let currentScroll = window.pageYOffset

      if (currentScroll > 20 && this.prevScroll < currentScroll) {
        this.hideNavbar = true
      } else {
        this.hideNavbar = false
      }
      this.prevScroll = currentScroll

      // Check if we're at top of page
      // if (window.pageYOffset > 10) {
      //   if (this.scrollAtTop === true) {
      //     this.setScrollAtTop(false);
      //   }
      // } else if (this.scrollAtTop === false) {
      //   this.setScrollAtTop(true);
      // }
    },
    pad(num, size) {
      let s = '000' + num
      return s.substr(s.length - size)
    },
  },
  render() {
    return this.$slots.default({
      mobileSidebarOpen: this.mobileSidebarOpen,
      desktopSidebarOpen: this.desktopSidebarOpen,
      sidebarSubMenu: this.sidebarSubMenu,
      toggleMobileSidebar: this.toggleMobileSidebar,
      toggleDesktopSidebar: this.toggleDesktopSidebar,
      scrollAtTop: this.scrollAtTop,
      itemCount: this.itemCount,
      hideNavbar: this.hideNavbar,
      pad: this.pad,
      announcementBarExists: this.announcementBarExists,
    })
  },
}
</script>
